import React from 'react';
import "../Donate/Donate.css"

const Blog = () => {
  return (
    <div>
       <header className='event-header'>
            <section>
              <h3>Our Blog</h3>
            </section>
        </header>

        <article className='event-main'>
            <h4>Last Posts</h4>
            <hr/>
        </article>

    </div>
  )
}

export default Blog